module.exports = __webpack_public_path__ + "img/level_3.42bc1553.svg";